import { SexType } from '@lmt/shared-types';
import { parse } from 'date-fns';

export type PatientEgkCardData = {
  firstName: string;
  lastName: string;
  titleAsString?: string;
  dateOfBirth: Date;
  sex: SexType;
  location: string;
  address: string;
  postcode: string;
  insuranceNumber: string;
  healthInsuranceCompany: string;
  healthInsuranceCompanyNumber: string;
  healthInsuranceCompanyShortName: string;
};

export type CardReadingResult = {
  data?: PatientEgkCardData;
  error?: Error;
};

export function convertSexType(sex: string) {
  return sex === 'M'
    ? SexType.Male
    : sex === 'W'
      ? SexType.Female
      : SexType.Undefined;
}

export function convertDateOfBirth(date: string) {
  return parse(date, 'yyyyMMdd', new Date());
}
